import { Button } from "@choose/ui/button";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@choose/ui/input-group";
import { Separator } from "@choose/ui/separator";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PlusIcon, SearchIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { SnippetTagList } from "~/components/common/settings/snippets/snippet-tag-list";
import { useSnippetTagFilters } from "~/stores/snippet-tags-store";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/snippet-tags/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { filters, setFilters } = useSnippetTagFilters();

  return (
    <>
      <title>{`${t("settings.snippet_tags.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
              <div>
                <h1 className="text-2xl">{t("settings.snippet_tags.title")}</h1>
                <p className="text-muted-foreground mt-1 text-sm text-balance">
                  {t("settings.snippet_tags.subtitle")}
                </p>
              </div>
              <div>
                <Button
                  type="button"
                  nativeButton={false}
                  render={
                    <Link to="/settings/snippet-tags/add">
                      <PlusIcon />
                      {t("settings.snippet_tags.add")}
                    </Link>
                  }
                />
              </div>
            </div>
          </header>
          <Separator className="my-8" />
          <div className="flex flex-col gap-4">
            <InputGroup>
              <InputGroupAddon align="inline-start">
                <SearchIcon />
              </InputGroupAddon>

              <InputGroupInput
                value={filters.search}
                onChange={(e) =>
                  setFilters({ ...filters, search: e.target.value })
                }
                placeholder={t("settings.snippet_tags.search.placeholder")}
              />
              {filters.search ? (
                <InputGroupAddon align="inline-end">
                  <InputGroupButton
                    size="icon-xs"
                    onClick={() => setFilters({ ...filters, search: "" })}
                  >
                    <XIcon />
                  </InputGroupButton>
                </InputGroupAddon>
              ) : null}
            </InputGroup>

            <SnippetTagList filters={filters} />
          </div>
        </div>
      </div>
    </>
  );
}
